import { isMocks } from 'common/navUtils';
import { EEnvironments, TRP_INTERNAL_DOMAIN } from 'utils/constants';
import { RootState } from '../state/store';

export const API_MAX_RETRY_COUNT = 0;
export const MOCK_API_PATH = '/api';

export const createBaseUrl = (
  appConfig: RootState['appConfig'],
  servicePath?: string,
): string => {
  if (appConfig.environment === EEnvironments.SANDBOX && isMocks()) {
    return `${MOCK_API_PATH}`;
  } else if (isInternalDomain()) {
    return `${appConfig.internalApiDomain}${servicePath ? appConfig.apiBasePath : ''}`;
  }
  return `${appConfig.apiDomain}${servicePath ?? ''}`;
};

export const setHeaders = (headers: Headers, apiKey: string | undefined): Headers => {
  headers.set('apiKey', apiKey ?? 'NO APIKEY PRESENT');
  headers.set('x-trp-requested-with', 'asset-transfer');
  headers.set('trp-consumer-initial', 'asset-transfer');
  headers.set('Accepts', 'application/json');
  headers.set('Content-Type', 'application/json');

  return headers;
};

export const isInternalDomain = () => {
  if (!window.location?.hostname) {
    return false;
  }
  return window.location.hostname.includes('.' + TRP_INTERNAL_DOMAIN);
};
